import React, { useState } from 'react';
import { SearchableDocViewer } from '../document-utils/SearchableDocViewer';
import FileDrop from './FileDrop';
import { HeaderTabs } from '../base/HeaderTabs';
import { HighlightedPDFViewer } from './HighlightedPDFViewer';
import { FileList } from './FileList';
import { isNonEmpty } from '../../utils/arrayUtils';
export const FileContainer = ({ showSearchablePDFViewer, showHeaderTabs = true, enableSampleDocument = true, documents, setDocuments, onDeleteDocument, currentIndex, setCurrentIndex, images, resetFiles, highlights, setHighlights, fileDropText, uploadMultiple, accept, }) => {
    const [currentTabIndex, setCurrentTabIndex] = useState(0);
    const setSampleFile = async () => {
        const fileUrl = 'https://relyant-public-assets.s3.us-west-2.amazonaws.com/sample0.pdf';
        setDocuments([{ url: fileUrl, filename: 'sample0.pdf' }]);
        setCurrentIndex(0);
    };
    const tabs = [
        {
            id: 'tab-reset',
            label: 'Reset',
            onClick: resetFiles,
        },
    ];
    const haveDocuments = isNonEmpty(documents);
    const haveImages = isNonEmpty(images);
    if (haveImages) {
        tabs.unshift({
            id: 'tab-images',
            label: 'Images',
            onClick: undefined,
        });
    }
    if (haveDocuments) {
        tabs.unshift({
            id: 'tab-pdfs',
            label: 'PDFs',
            onClick: undefined,
        });
    }
    return (React.createElement(React.Fragment, null, haveImages || haveDocuments ? (React.createElement("div", { style: { width: '100%' } },
        showHeaderTabs && (React.createElement(HeaderTabs, { tabs: tabs, currentTabIndex: currentTabIndex, setCurrentTabIndex: setCurrentTabIndex })),
        haveDocuments && tabs[currentTabIndex].id === 'tab-pdfs' ? (React.createElement("div", null,
            React.createElement(FileList, { documents: documents, setDocuments: setDocuments, indexDocument: currentIndex, setIndexDocument: setCurrentIndex, onDeleteFile: onDeleteDocument }),
            showSearchablePDFViewer && isNonEmpty(highlights) ? (React.createElement("div", { style: { textAlign: 'center' } },
                React.createElement(HighlightedPDFViewer, { fileUrl: documents[currentIndex].url, highlights: highlights }))) : showSearchablePDFViewer ? (React.createElement("div", { style: { textAlign: 'center' } },
                React.createElement(SearchableDocViewer, { fileUrl: documents[currentIndex].url }))) : null)) : null)) : (React.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
        React.createElement(FileDrop, { text: fileDropText || 'Click or drag inspection documents to this area to upload', setFiles: setDocuments, multiple: uploadMultiple, accept: accept, styleText: { fontSize: 16, fontWeight: 500 } }),
        enableSampleDocument && (React.createElement("div", null,
            React.createElement("div", { style: { marginTop: 8 } }, "Or use our sample files:"),
            React.createElement("div", { className: "clickable", style: { color: 'blue', marginTop: 8 }, onClick: setSampleFile, role: "button", onKeyDown: () => { }, tabIndex: 0 }, "Sample document")))))));
};
